import React from "react";
import { FormSelect } from "@jsq/ds/forms";
import { Section } from "../../types";

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  "data-testid"?: string;
  sections?: Section[] | null;
};

const SectionSelector: React.FC<Props> = ({
  name,
  label,
  placeholder = "Select a section (optional)",
  disabled = false,
  "data-testid": testId,
  sections = null,
}) => {
  const isSectionsAvailable = sections && sections.length > 0;

  return (
    <FormSelect
      name={name}
      label={label}
      placeholder={!isSectionsAvailable ? "No sections available" : placeholder}
      disabled={disabled || !isSectionsAvailable}
      data-testid={testId}
    >
      <FormSelect.Section>
        {[
          <FormSelect.Option key="none" value="">
            None
          </FormSelect.Option>,
          ...(sections || []).map((section) => (
            <FormSelect.Option key={section.id} value={section.id}>
              {section.description ? `${section.name} - ${section.description}` : section.name}
            </FormSelect.Option>
          )),
        ]}
      </FormSelect.Section>
    </FormSelect>
  );
};

export default SectionSelector;
